import { createRoot } from 'react-dom/client'
import { demos } from '@/landing/demos'
import { SettingsProvider } from '@/lib/settings'

// Plays the game demos on the website. Until this runs (or without JavaScript) each panel shows a still picture.
for (const panel of document.querySelectorAll<HTMLElement>('[data-demo]')) {
  const Demo = demos[panel.dataset.demo ?? '']
  if (!Demo) continue
  panel.replaceChildren()
  createRoot(panel).render(
    <SettingsProvider>
      <Demo />
    </SettingsProvider>,
  )
}
